<template>
  <div class="supportHubs">
    <div class="head-box">
      <h4>任务批次管理</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入任务标题"
          v-model="searchValue"
          class="c-search"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew(1)" class="c-m-l-10">新建任务</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectSettles"
          highlight-current-row
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="任务标题" fixed show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click.native.prevent="handleRowClick(scope.row)" type="text">
                {{ scope.row.title }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="任务批次编号" show-overflow-tooltip></el-table-column>

          <el-table-column
            prop="sourceType"
            label="任务来源类型"
            show-overflow-tooltip
            :formatter="formatSourceType"
          ></el-table-column>

          <el-table-column label="创建日期查询条件" show-overflow-tooltip>
            <template slot-scope="scope">
              <template v-if="scope.row.exts.startTime && scope.row.exts.endTime">
                {{ scope.row.exts.startTime.split(' ')[0] }} 至
                {{ scope.row.exts.endTime.split(' ')[0] }}
              </template>
              <template v-else-if="scope.row.exts.startTime">
                从 {{ scope.row.exts.startTime.split(' ')[0] }} 开始
              </template>
              <template v-else-if="scope.row.exts.endTime">
                截止到 {{ scope.row.exts.endTime.split(' ')[0] }}
              </template>
              <!-- 兼容旧数据，历史数据只保存了endTime -->
              <template v-else-if="scope.row.endTime">
                截止到 {{ scope.row.endTime.split(' ')[0] }}
              </template>
              <template v-else>
                不限制
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
          <el-table-column
            prop="userId"
            label="执行客服"
            show-overflow-tooltip
            :formatter="formatUsers"
          ></el-table-column>

          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <!-- 扩展字段 -->
          <c-table :fields="extFields"></c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 
        任务来源类型 sourceType
        1: 线索 lead
        2: 客户 contacts
        3: 工单 serviceAppointment
        4: 订单 order
        5: 质保 warranty
    -->
    <el-dialog
      title="新增任务"
      :close-on-click-modal="false"
      :visible.sync="openDetail"
      custom-class="c-dialog supportHub-dialog"
      width="1300px"
    >
      <el-form :model="formData" :rules="rules" ref="formData" size="mini">
        <div style="border-bottom:1px solid #e8eaec;padding-bottom:10px;display:flex;gap:10px">
          <el-form-item label="任务标题" prop="title" class="c-flex-1">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item
            label="任务来源类型"
            prop="sourceType"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
            class="c-flex-1"
          >
            <el-select v-model="formData.sourceType" clearable @change="sourceTypeChange()">
              <el-option
                v-for="(item, i) in options.taskSourceType"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="c-date-picker c-flex-1">
            <template slot="label">
              {{ formatSourceType(null, null, formData.sourceType) || '' }}创建日期
            </template>
            <el-date-picker
              v-model="formData.exts.datetimerange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              @change="query()"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="exts.remark"
            :rules="{
              required: false,
              trigger: ['blur', 'change'],
              message: '备注不能为空'
            }"
            class="c-flex-1"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 2 }"
              v-model="formData.exts.remark"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="执行客服"
            prop="userId"
            :rules="{
              required: true,
              trigger: ['blur', 'change'],
              message: '执行客服不能为空'
            }"
            class="c-flex-1"
          >
            <el-select v-model="formData.userId" clearable>
              <template v-for="item in options.users">
                <el-option :key="item.value" :label="item.name" :value="item.value"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="formData.sourceType" class="c-m-t-10 c-m-b-10 c-flex c-flex-between c-flex-item">
          <div>
            <span class="f-w-b c-m-r-5">筛选条件</span>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                1~多个“且”：同时满足所有条件
                <br />
                1~多个“或”：至少满足一个条件
                <br />
                “且”和“或”同时存在：同时满足所有是“且”的条件，并且至少满足一个是“或”的条件
              </div>
              <i class="el-icon-info c_blue"></i>
            </el-tooltip>
          </div>
          <div>
            <el-button type="primary" @click="query()">
              筛选
              <i class="el-icon-search el-icon--right"></i>
            </el-button>
            <el-button type="info" plain @click="sourceTypeChange">
              清空筛选条件
              <i class="el-icon-delete el-icon--right"></i>
            </el-button>
            <el-button v-if="filterShow" type="info" plain @click="filterShow = false">
              收起筛选
              <i class="el-icon-arrow-up el-icon--right"></i>
            </el-button>
            <el-button v-else type="info" plain @click="filterShow = true">
              展开筛选
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </div>
        </div>

        <el-row v-if="filterShow" :gutter="24" class="c-flex c-flex-wrap">
          <el-col
            v-for="(item, i) in formData.exts.filters"
            :key="i"
            :span="12"
            class="c-flex c-m-b-10"
            style="gap: 10px"
          >
            <el-input
              :value="item.nameDisp"
              disabled
              style="width:125px;min-width:125px;"
            ></el-input>
            <el-select
              v-model="item.condition"
              clearable
              style="width:100px;min-width:100px;"
              @change="conditionChange(item)"
            >
              <template v-for="(condition, i) in options.filterCondition">
                <el-option
                  :key="i"
                  v-if="conditionShow(item).indexOf(condition.value) != -1"
                  :label="condition.label"
                  :value="condition.value"
                ></el-option>
              </template>
            </el-select>
            <el-cascader
              v-if="item.type == 'area'"
              :options="area.options"
              :props="{
                multiple: true,
                checkStrictly: item.frontEndConfig.propsCheckStrictly || false,
                expandTrigger: 'hover',
                emitPath: false
              }"
              v-model="item.values"
              clearable
              collapse-tags
              placeholder="请选择"
              :disabled="
                item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
              "
              style="flex:1"
            ></el-cascader>
            <el-cascader
              v-else-if="item.type == 'cascade'"
              :options="options[item.valueOption]"
              :props="{
                multiple: true,
                checkStrictly: item.frontEndConfig.propsCheckStrictly || false,
                expandTrigger: 'hover',
                label: 'name',
                emitPath: false
              }"
              v-model="item.values"
              clearable
              collapse-tags
              placeholder="请选择"
              :disabled="
                item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
              "
              style="flex:1"
            ></el-cascader>
            <el-date-picker
              v-else-if="item.type == 'date'"
              v-model="item.values"
              :type="item.condition == 'between' ? 'daterange' : 'date'"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="
                item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
              "
              style="flex:1"
            ></el-date-picker>
            <el-time-picker
              v-else-if="item.type == 'time'"
              v-model="item.values"
              value-format="HH:mm:ss"
              :is-range="item.condition == 'between' ? true : false"
              placeholder="选择时间"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :disabled="
                item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
              "
              style="flex:1"
            ></el-time-picker>
            <el-date-picker
              v-else-if="item.type == 'datetime'"
              v-model="item.values"
              :type="item.condition == 'between' ? 'datetimerange' : 'datetime'"
              :default-time="item.condition == 'between' ? ['00:00:00', '23:59:59'] : '00:00:00'"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :disabled="
                item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
              "
              style="flex:1"
            ></el-date-picker>
            <div
              v-else-if="
                (item.type == 'number' || item.type == 'digit') && item.condition == 'between'
              "
              class="c-flex c-flex-1 c_item_center"
            >
              <el-input-number
                v-model="item.start"
                placeholder="最小值"
                :controls="false"
                :disabled="
                  item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
                "
                class="c-flex-1"
              ></el-input-number>
              <span class="c-m-v-10">-</span>
              <el-input-number
                v-model="item.end"
                placeholder="最大值"
                :controls="false"
                :disabled="
                  item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
                "
                class="c-flex-1"
              ></el-input-number>
            </div>
            <!-- 当字段类型为数字时，“大于等于”和“小于等于”只允许输入单值 -->
            <el-input
              v-else-if="
                (item.condition == '<=' || item.condition == '>=') &&
                  (item.type == 'number' || item.type == 'digit')
              "
              v-model="item.values"
              placeholder="请输入数字"
            ></el-input>
            <el-select
              v-else
              v-model="item.values"
              multiple
              clearable
              filterable
              :allow-create="!item.valueOption ? true : false"
              :default-first-option="!item.valueOption ? true : false"
              :placeholder="!item.valueOption ? '支持创建多条' : '请选择'"
              :disabled="
                item.condition == 'doesNotExists' || item.condition == 'exists' ? true : false
              "
              style="flex:1"
              @change="valueChange(item)"
            >
              <template v-if="item.valueOption">
                <el-option
                  v-for="(option, i) in options[item.valueOption]"
                  :key="i"
                  :label="option.label"
                  :value="item.frontEndConfig.number ? Number(option.value) : option.value"
                ></el-option>
              </template>
            </el-select>
            <el-button
              plain
              style="height: fit-content;"
              :type="item.relation == 'or' ? 'danger' : ''"
              @click="
                () => {
                  if (item.relation == 'and') {
                    item.relation = 'or';
                  } else {
                    item.relation = 'and';
                  }
                }
              "
            >
              {{ item.relation == 'and' ? '且' : '或' }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- sourceType：1 线索 lead -->
      <el-table
        v-if="formData.sourceType == 'lead'"
        ref="table1"
        height="300px"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        stripe
        @selection-change="selectChange"
        row-key="_id"
        class="c-table-border"
      >
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55"
          fixed
        ></el-table-column>
        <c-table :fields="leadFields"></c-table>
      </el-table>
      <!-- sourceType:2 客户 contacts -->
      <el-table
        v-else-if="formData.sourceType == 'contacts'"
        ref="table2"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        stripe
        @selection-change="selectChange"
        row-key="_id"
        class="c-table-border"
      >
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55"
          fixed
        ></el-table-column>
        <c-table :fields="contactsFields"></c-table>
      </el-table>
      <!-- sourceType:3 工单列表 serviceAppointment -->
      <el-table
        v-else-if="formData.sourceType == 'serviceAppointment'"
        ref="table3"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        row-key="_id"
        border
        stripe
        @selection-change="selectChange"
        class="c-table-border"
      >
        <el-table-column
          fixed="left"
          :reserve-selection="true"
          type="selection"
          width="55"
        ></el-table-column>
        <c-table :fields="serviceAppointmentFields"></c-table>
      </el-table>
      <!-- sourceType:4 订单 order -->
      <el-table
        v-else-if="formData.sourceType == 'order'"
        ref="table4"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        stripe
        @selection-change="selectChange"
        row-key="_id"
        class="c-table-border"
      >
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55"
          fixed
        ></el-table-column>
        <c-table :fields="orderFields"></c-table>
      </el-table>
      <!-- sourceType：5 质保 warranty-->
      <el-table
        v-else-if="formData.sourceType == 'warranty'"
        ref="table5"
        height="100%"
        :data="items.fpi.data"
        v-loading="items.loading"
        border
        stripe
        @selection-change="selectChange"
        row-key="_id"
        class="c-table-border"
      >
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55"
          fixed
        ></el-table-column>
        <!-- <c-table :fields="warrantyFields"></c-table> -->
        <el-table-column
          prop="ownerName"
          label="委托方"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="contractdocNum"
          label="合同编号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="fileName" label="客户姓名" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="InsurancePolicyNum"
          label="质保凭证流水号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="contactsAddress"
          label="通讯地址"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="guaranteedTime2"
          label="保障年限"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="address"
          label="维修服务地址"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ownerPhone"
          label="被保险人电话"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="propertyLoss"
          label="财产损失"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="partyB" label="服务中心名称" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="c-flex c_item_center c-flex-between" v-if="formData.sourceType">
        <div class="c-flex c_item_center">
          <span class="c-font-13 c-m-r-10">
            共 {{ items.fpi.total }} 条，已选 {{ items.selectedRows.length }} 条
          </span>
          <el-pagination
            class="pagination"
            @size-change="pageSizeChangeTable"
            @current-change="pageChangeTable"
            :current-page="items.fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="items.fpi.rows"
            layout="sizes, prev, pager, next, jumper"
            :total="items.fpi.total"
          ></el-pagination>
        </div>
        <div>
          <el-button type="primary" @click="doSave">提 交</el-button>
          <el-button @click="doInit">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  activated() {
    window.$this = this;
  },
  name: 'Settles',
  data() {
    window.$this = this;
    return {
      name: 'settle',
      fpi: {},
      // 明细
      items: {
        fpi: {
          data: []
        },
        selectedRows: [],
        loading: false
      },
      searchValue: '',
      openDetail: false,
      formData: {
        exts: {
          remark: '',
          filters: [],
          datetimerange: []
        }
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_filterCondition: { codeId: 'filterCondition' }, // 过滤条件类型
        codecfg_type: { codeId: 'settleType' }, //结算对象
        codecfg_taskSourceType: { codeId: 'taskSourceType' }, //任务来源类型
        codecfg_contractSourceType: { codeId: 'sourceType' }, //信息来源
        codecfg_contractType: { codeId: 'contractType' },
        cascadeCode_repairParts: { codeId: 'repairParts' }, //工单部位
        codecfg_contractStatus: { codeId: 'contractStatus' },
        codecfg_payState: { codeId: 'payState1' },
        codecfg_deductType: { codeId: 'deductType' },
        codecfg_serviceType: { codeId: 'serviceType' },
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_sourceType: { codeId: 'sourceType' },
        codecfg_reasons1: { codeId: 'reasons1' },
        codecfg_reasons2: { codeId: 'reasons2' },
        codecfg_sTerritory: { codeId: 'sTerritory' },
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_STATUS: { codeId: 'STATUS' },
        users: []
      },
      selectedRows: [], //勾选的结算单
      selectLeadsRows: [], //勾选线索数据
      area: {
        props: {
          checkStrictly: true
        },
        options: this.osg.areaList
      },
      filterShow: true // 收起和展开筛选状态
    };
  },
  mounted() {
    this.doInit();
    this.getUsers();
    this.osg.codeoption(() => {
      this.osg.getFpi();
      this.getData();
    });
    this.osg.getFields('lead', () => {}, null, 'leadFields');
    this.osg.getFields('contacts', () => {}, null, 'contactsFields');
    this.osg.getFields('serviceAppointment', () => {}, null, 'serviceAppointmentFields');
    this.osg.getFields('order', () => {}, null, 'orderFields');
    this.osg.getFields('warranty', () => {}, null, 'warrantyFields');
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    formatSourceType(row, column, cellValue) {
      return this.osg.codelabel('taskSourceType', cellValue);
    },
    formatUsers(row, column, cellValue) {
      return this.osg.codelabel('users', cellValue);
    },
    formatPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    pageSizeChangeTable(pageSize) {
      this.items.fpi.rows = pageSize;
      if (this.formData.sourceType == 'lead') {
        this.getLeads();
      }
      if (this.formData.sourceType == 'contacts') {
        this.getContacts();
      }
      if (this.formData.sourceType == 'serviceAppointment') {
        this.getServiceAppointments();
      }
      if (this.formData.sourceType == 'order') {
        this.getOrders();
      }
      if (this.formData.sourceType == 'warranty') {
        this.getWarrantys();
      }
    },
    pageChangeTable(currentPage) {
      this.items.fpi.page = currentPage;
      if (this.formData.sourceType == 'lead') {
        this.getLeads();
      }
      if (this.formData.sourceType == 'contacts') {
        this.getContacts();
      }
      if (this.formData.sourceType == 'serviceAppointment') {
        this.getServiceAppointments();
      }
      if (this.formData.sourceType == 'order') {
        this.getOrders();
      }
      if (this.formData.sourceType == 'warranty') {
        this.getWarrantys();
      }
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        exts: {
          remark: '',
          filters: [],
          datetimerange: []
        }
      };
      this.items = {
        fpi: {
          data: []
        },
        selectedRows: [],
        loading: false
      };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:title|string#or': this.searchValue,
        'regex:num|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      this.osg.setFpi(params);
      this.osg.ajax('basic/supportHub/querySupportHub.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row); //避免编辑内容后取消导致显示异常
      row.exts = row.exts || {};
      this.$util.renderExtField(this.extFields, row);
      this.$forceUpdate();

      row.exts.filters = row.exts.filters || [];
      row.exts.datetimerange = row.exts.datetimerange || [];
      this.formData = row;
      this.query(true);
      this.openDetail = true;
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      let params = this.$util.deepCopy(this.formData);
      if (this.osg.validate()) {
        params.exts.startTime = params.exts.startTime && params.exts.startTime + ' 00:00:00';
        params.exts.endTime = params.exts.endTime && params.exts.endTime + ' 23:59:59';
        // 结算来源id，targetType=0时为工单id，1时为订单id，2时为合同id, 3为结算明细id
        let sourceTypeIdList = [];
        for (var item of this.items.selectedRows) {
          if (sourceTypeIdList.indexOf(item._id) == -1) sourceTypeIdList.push(item._id);
        }
        if (sourceTypeIdList.length == 0) {
          this.osg.alert('请至少勾选一条数据!', 'warning');
          return;
        }
        params.sourceTypeIdList = sourceTypeIdList;

        this.osg.ajax('/basic/supportHub/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    sourceTypeChange() {
      this.items.fpi.data = []; // 解决切换table反应慢的问题
      this.items.fpi.page = 1;
      this.items.fpi.rows = 20;

      let filters = [];
      if (this.formData.sourceType) {
        this[this.formData.sourceType + 'Fields'].map(item => {
          if (item.showList && item.showList.indexOf('11') != -1) {
            if (
              !item.valueOption &&
              item.type != 'date' &&
              item.type != 'time' &&
              item.type != 'datetime' &&
              item.type != 'number' &&
              item.type != 'digit' &&
              !item.frontEndConfig.number
            ) {
              // 文本类型字段，默认条件“包含”
              item.condition = 'contains';
            } else {
              if (item.type == 'date' || item.type == 'time' || item.type == 'datetime') {
                // 时间类型字段，默认条件区间
                item.condition = 'between';
              } else {
                // 数字、选项类型字段，默认条件区间
                item.condition = '=';
              }
            }
            item.values = [];
            item.relation = 'and';
            // 筛选条件中只保留用到的字段
            let field = {
              nameDisp: item.nameDisp,
              name: item.name,
              type: item.type,
              preset: item.preset,
              valueOption: item.valueOption,
              frontEndConfig: item.frontEndConfig,
              condition: item.condition,
              values: item.values,
              start: item.start,
              end: item.end,
              relation: item.relation
            };
            filters.push(field);
          }
        });
      }
      this.formData.exts.filters = filters;
      this.query();
    },
    conditionShow(field) {
      if (!field.valueOption) {
        if (field.type == 'date' || field.type == 'time' || field.type == 'datetime') {
          return ['<=', '>=', 'doesNotExists', 'exists', 'between'];
          // 时间类型没有等于和不等于，使用区间替代
        } else if (field.type == 'number' || field.type == 'digit' || field.frontEndConfig.number) {
          return ['=', '!=', '<=', '>=', 'doesNotExists', 'exists', 'between'];
        } else {
          return ['=', '!=', 'doesNotExists', 'exists', 'contains'];
        }
      } else {
        return ['=', '!=', 'doesNotExists', 'exists'];
      }
    },
    conditionChange(item) {
      if (item.condition == 'doesNotExists' || item.condition == 'exists') {
        if (item.type == 'date' || item.type == 'time' || item.type == 'datetime') {
          item.values = '';
        } else {
          item.values = [];
          // 如果字段类型是数字，将区间最小值和最大值赋值为空
          delete item.start;
          delete item.end;
        }
      } else if (item.type == 'number' || item.type == 'digit') {
        if (item.condition == '>=' || item.condition == '<=') {
          item.values = '';
          item.start = '';
          item.end = '';
        } else {
          item.values = [];
          item.start = '';
          item.end = '';
        }
      } else if (item.type == 'date' || item.type == 'time' || item.type == 'datetime') {
        if (item.condition == 'between') {
          // 时间范围类型组件值为数组
          item.values = [];
        } else {
          // 时间类型组件值为字符串
          item.values = '';
        }
      }
    },
    valueChange(item) {
      // 条件值变更时，如果已选择多个条件值，当条件为“包含时”自动改为“等于”，后台过滤模糊查询不支持多个值。
      if (item.condition == 'contains' && item.values && item.values.length > 1) {
        item.condition = '=';
      }
    },
    setFilter() {
      let params = {};
      for (let row of this.formData.exts.filters) {
        let condition;
        switch (row.condition) {
          case 'contains': //包含
            if (row.values.length > 1) {
              condition = 'in';
            } else {
              condition = 'regex';
            }
            break;
          case '=': //等于
            condition = 'in';
            break;
          case '!=': //不等于
            condition = 'nin';
            break;
          case '<=': //小于等于
            condition = 'lte';
            break;
          case '>=': //大于等于
            condition = 'gte';
            break;
          case 'between': //区间
            condition = 'between';
            break;
          case 'doesNotExists': //为空
            condition = 'exists';
            break;
          case 'exists': //不为空
            condition = 'exists';
            break;
          default:
            break;
        }
        if (!condition) condition;

        let fieldName;
        if (row.preset) {
          fieldName = row.name;
        } else {
          fieldName = 'exts.' + row.name;
        }

        if (row.condition == 'doesNotExists') {
          params[`${condition}:${fieldName}|boolean#${row.relation}`] = false;
        } else if (row.condition == 'exists') {
          params[`${condition}:${fieldName}|boolean#${row.relation}`] = true;
        } else if (row.type == 'number' || row.type == 'digit' || row.frontEndConfig.number) {
          if (row.condition == 'between') {
            // 数字：区间
            if (row.start || row.start === 0 || (row.start || row.start === 0)) {
              if (row.start || row.start === 0) {
                params[`gte:${fieldName}|integer#${row.relation}`] = row.start;
              }
              if (row.end || row.end == 0) {
                params[`lte:${fieldName}|integer#${row.relation}`] = row.end;
              }
            } else {
              continue;
            }
          } else if (row.condition == '>=' || row.condition == '<=') {
            // 数字：大于等于 小于等于
            if (row.values || row.values == 0) {
              params[`${condition}:${fieldName}|integer#${row.relation}`] = row.values;
            } else {
              continue;
            }
          } else {
            // 数字：等于 不等于
            if (row.values && row.values.length > 0) {
              params[`${condition}:${fieldName}|array-integer#${row.relation}`] = row.values.join();
            } else {
              continue;
            }
          }
        } else if (row.type == 'date' || row.type == 'time' || row.type == 'datetime') {
          let type = row.type == 'date' ? 'date' : 'datetime';
          if (row.values && row.values.length > 0) {
            if (row.condition == 'between') {
              // 日期时间：区间
              params[`gte:${fieldName}|${type}#${row.relation}`] = row.values[0];
              params[`lte:${fieldName}|${type}#${row.relation}`] = row.values[1];
            } else {
              // 日期时间：等于 不等于 大于等于 小于等于
              params[`${condition}:${fieldName}|${type}#${row.relation}`] = row.values;
            }
          } else {
            continue;
          }
        } else {
          if (row.values && row.values.length > 0) {
            params[
              `${condition}:${fieldName}|${condition == 'regex' ? 'string' : 'array'}#${
                row.relation
              }`
            ] = row.values.join();
          } else {
            continue;
          }
        }
      }
      return params;
    },

    query(edit) {
      // 必须选择任务来源类型才请求数据
      if (!this.formData.sourceType && this.formData.sourceType != 0) {
        return;
      }

      // 任务来源类型:线索
      if (this.formData.sourceType == 'lead') {
        this.getLeads(edit);
        return;
      }

      // 任务来源类型:客户
      if (this.formData.sourceType == 'contacts') {
        this.getContacts(edit);
        return;
      }

      // 任务来源类型:工单
      if (this.formData.sourceType == 'serviceAppointment') {
        this.getServiceAppointments(edit);
        return;
      }

      // 任务来源类型:订单
      if (this.formData.sourceType == 'order') {
        this.getOrders(edit);
        return;
      }

      // 任务来源类型:质保
      if (this.formData.sourceType == 'warranty') {
        this.getWarrantys(edit);
        return;
      }
    },
    // 查询工单
    getServiceAppointments(edit) {
      if (this.formData.exts.datetimerange) {
        this.formData.exts.startTime = this.formData.exts.datetimerange[0];
        this.formData.exts.endTime = this.formData.exts.datetimerange[1];
      } else {
        this.formData.exts.startTime = null;
        this.formData.exts.endTime = null;
      }

      this.items.loading = true;
      var params = {
        page: this.items.fpi.page || 1,
        rows: this.items.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'gte:createTime|datetime#and':
          this.formData.exts.startTime && this.formData.exts.startTime + ' 00:00:00',
        'lte:createTime|datetime#and':
          this.formData.exts.endTime && this.formData.exts.endTime + ' 23:59:59'
      };

      params = Object.assign(params, this.setFilter());

      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table3.doLayout();
            if (edit) {
              // 编辑任务单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection('table3', rows);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },

    // 查询线索
    getLeads(edit) {
      this.items.loading = true;

      // 过滤:结算明细创建日期范围
      if (this.formData.exts.datetimerange) {
        this.formData.exts.startTime = this.formData.exts.datetimerange[0];
        this.formData.exts.endTime = this.formData.exts.datetimerange[1];
      } else {
        this.formData.exts.startTime = null;
        this.formData.exts.endTime = null;
      }

      var params = {
        page: this.items.fpi.page || 1,
        rows: this.items.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'gte:createTime|datetime#and':
          this.formData.exts.startTime && this.formData.exts.startTime + ' 00:00:00',
        'lte:createTime|datetime#and':
          this.formData.exts.endTime && this.formData.exts.endTime + ' 23:59:59'
      };

      params = Object.assign(params, this.setFilter());

      this.osg.ajax(
        'basic/lead/query.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table1.doLayout();
            if (edit) {
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection('table1', rows);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询客户
    getContacts(edit) {
      this.items.loading = true;

      // 过滤:结算明细创建日期范围
      if (this.formData.exts.datetimerange) {
        this.formData.exts.startTime = this.formData.exts.datetimerange[0];
        this.formData.exts.endTime = this.formData.exts.datetimerange[1];
      } else {
        this.formData.exts.startTime = null;
        this.formData.exts.endTime = null;
      }

      var params = {
        page: this.items.fpi.page || 1,
        rows: this.items.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'gte:createTime|datetime#and':
          this.formData.exts.startTime && this.formData.exts.startTime + ' 00:00:00',
        'lte:createTime|datetime#and':
          this.formData.exts.endTime && this.formData.exts.endTime + ' 23:59:59'
      };

      params = Object.assign(params, this.setFilter());

      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table2.doLayout();
            if (edit) {
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection('table2', rows);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询订单数据
    getOrders(edit) {
      this.items.loading = true;

      // 过滤:结算明细创建日期范围
      if (this.formData.exts.datetimerange) {
        this.formData.exts.startTime = this.formData.exts.datetimerange[0];
        this.formData.exts.endTime = this.formData.exts.datetimerange[1];
      } else {
        this.formData.exts.startTime = null;
        this.formData.exts.endTime = null;
      }

      var params = {
        page: this.items.fpi.page || 1,
        rows: this.items.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'gte:createTime|datetime#and':
          this.formData.exts.startTime && this.formData.exts.startTime + ' 00:00:00',
        'lte:createTime|datetime#and':
          this.formData.exts.endTime && this.formData.exts.endTime + ' 23:59:59'
      };

      params = Object.assign(params, this.setFilter());

      this.osg.ajax(
        'basic/order/query.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table4.doLayout();

            if (edit) {
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection('table4', rows);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询质保数据
    getWarrantys(edit) {
      this.items.loading = true;

      // 过滤:结算明细创建日期范围
      if (this.formData.exts.datetimerange) {
        this.formData.exts.startTime = this.formData.exts.datetimerange[0];
        this.formData.exts.endTime = this.formData.exts.datetimerange[1];
      } else {
        this.formData.exts.startTime = null;
        this.formData.exts.endTime = null;
      }

      var params = {
        page: this.items.fpi.page || 1,
        rows: this.items.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'gte:createTime|datetime#and':
          this.formData.exts.startTime && this.formData.exts.startTime + ' 00:00:00',
        'lte:createTime|datetime#and':
          this.formData.exts.endTime && this.formData.exts.endTime + ' 23:59:59'
      };

      params = Object.assign(params, this.setFilter());

      this.osg.ajax(
        '/document/queryWarranty.do',
        params,
        res => {
          this.items.fpi = res;
          this.items.loading = false;
          this.$nextTick(() => {
            this.$refs.table5.doLayout();

            if (edit) {
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection('5', rows);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 指定选中明细
    toggleSelection(table, rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs[table].toggleRowSelection(row);
        });
      } else {
        this.$refs[table].clearSelection();
      }
    },
    // 选中明细行变化时触发
    selectChange(rows) {
      this.items.selectedRows = rows;
    },
    // 结算单列表多选
    selectSettles(rows) {
      this.selectedRows = rows;
    },
    getUsers() {
      this.osg.ajax(
        'user/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterBelongTo: '1',
          'in:roleIds|array#and': '812337714845629049'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
        },
        { noload: true }
      );
    },
    handleRowClick(row) {
      this.$router.push({
        path: `/SupportHub/${row._id}`
      });
      this.SetCachedViews({
        params: row.title,
        action: `/SupportHub/${row._id}`
      });
    }
  }
};
</script>
<style lang="scss">
#app .supportHubs {
  .supportHub-dialog {
    max-width: calc(100vw - 20px) !important;
    width: calc(100vw - 20px) !important;
    max-height: calc(100vh - 20px) !important;
    height: calc(100vh - 20px) !important;
    margin: 10px !important;
    .el-dialog__body {
      padding-bottom: 0;
    }
  }
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .c-date-picker {
    height: 33px !important;
  }
}
</style>
